module.exports = __webpack_public_path__ + "img/wx_link.a9debbfc.png";